import { Engine, Scene, ArcRotateCamera, FreeCamera } from 'babylonjs'
import * as GUI from 'babylonjs-gui'

// TODO: split config to another context, like fpsIndicator
export interface IContext3D {
  scene?: Scene
  engine?: Engine
  canvas3D?: HTMLCanvasElement
  camera?: ArcRotateCamera | FreeCamera
  modelReady?: boolean
  fpsIndicator?: HTMLDivElement
  fullScreenUI?: GUI.AdvancedDynamicTexture | null
}

class ContextManager {
  context: IContext3D = {
    modelReady: false,
  }

  get() {
    return this.context
  }

  set(context: Partial<IContext3D>) {
    this.context = { ...this.context, ...context }
  }
}

export const Context3D = new ContextManager()
